import { generatePath } from 'react-router-dom';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { OrganizationSettingsView } from '@dealstack/frontend/app/pages/Organization/Organization.types';

/**
 * The view enum values double as their URL segment, so the settings section survives a reload and
 * is linkable. Two views also carry the record they drill into.
 */
const VIEWS_WITH_ID = new Set<OrganizationSettingsView>([
	OrganizationSettingsView.User,
	OrganizationSettingsView.FundDeals,
	OrganizationSettingsView.ProgrammeDefaultsEmailTemplates,
	OrganizationSettingsView.DealDefaultsEmailTemplates,
]);

const ALL_VIEWS = new Set<string>(Object.values(OrganizationSettingsView));

export const organizationSettingsPath = (
	organizationId: string,
	view: OrganizationSettingsView,
	id?: string
): string => {
	const base = generatePath(ROUTES.ORGANIZATION_BY_ID, { organizationId });

	if (view === OrganizationSettingsView.General) {
		return base;
	}

	return VIEWS_WITH_ID.has(view) && id ? `${base}/${view}/${id}` : `${base}/${view}`;
};

/** Anything unrecognised falls back to General rather than rendering nothing. */
export const parseOrganizationSettingsPath = (
	splat: string | undefined
): { view: OrganizationSettingsView; id?: string } => {
	const [viewSegment, idSegment] = (splat ?? '').split('/').filter(Boolean);

	if (!viewSegment || !ALL_VIEWS.has(viewSegment)) {
		return { view: OrganizationSettingsView.General };
	}

	return { view: viewSegment as OrganizationSettingsView, id: idSegment };
};
